
import { Loader2 } from 'lucide-react';

interface LoadingScreenProps {
  message?: string;
  error?: string;
}

const LoadingScreen = ({ message = "Loading...", error }: LoadingScreenProps) => {
  return (
    <div className="flex-grow flex items-center justify-center">
      <div className="flex flex-col items-center">
        {error ? (
          <>
            <div className="text-red-500 mb-4 text-6xl">!</div>
            <p className="text-lg text-red-600 font-medium mb-2">Error</p>
            <p className="text-gray-600">{error}</p>
          </>
        ) : (
          <>
            <Loader2 className="h-12 w-12 text-brand-blue animate-spin mb-4" />
            <p className="text-lg text-gray-600">{message}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;
